import { useCallback } from 'react';

import { ApolloError } from '@apollo/client';
import { ICreateSupportCaseInput, SupportCaseProvider } from 'features/support/core/types';

import { useCreateSupportCaseMutation } from 'generated/graphql-gateway';
import { getErrorDialogForGraphQLCode, parseGraphQLErrorCodes, toError } from 'utils/errors';
import logger from 'utils/logger';

export const useKnowledgeForceCaseProvider = (): SupportCaseProvider => {
  const [createSupportCaseMutation] = useCreateSupportCaseMutation();

  const createCase = useCallback(
    async (caseInfo: ICreateSupportCaseInput) => {
      const { data } = await createSupportCaseMutation({ variables: { caseInfo } });
      return data?.createSupportCase?.caseId;
    },
    [createSupportCaseMutation]
  );

  return { createCase, handleError };
};

const handleError = (error: unknown): string | undefined => {
  let message: string | undefined;
  if (error instanceof ApolloError) {
    const [parsedApolloError] = parseGraphQLErrorCodes(error);
    if (parsedApolloError) {
      message = getErrorDialogForGraphQLCode(parsedApolloError)?.message;
    }
  }

  logger.error(`Failed to create knowledge force support case: ${toError(error).message}`);
  return message;
};
